/*
 * TPS — arama boş durum paneli <tps-search-empty> (owner, 2026-10-16).
 * Arama kutusu açık ve sorgu boşken Popüler Aramalar + Çok Satanlar gösterir; yazınca predictive-search devralır.
 * İçerik sections/tps-search-onerileri.liquid'den Section Rendering API ile BİR kez çekilir
 * (arama ikonuna gelince ön-yükleme, açılınca garanti). Ayarlar: Tema ayarları › Arama davranışı.
 *
 * Modal açıkken .search-modal'a `tps-search-idle` sınıfı verilir: masaüstünde kutu, sonuç ekranıyla aynı
 * yüksekliğe açılır; yazmaya başlayınca yükseklik değişmez (zıplama yok), panel gizlenir, sonuçlar gelir.
 */
if (!customElements.get('tps-search-empty')) {
  class TpsSearchEmpty extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.details = this.closest('details');
      this.modal = this.closest('.search-modal');
      this.form = this.closest('form');
      this.input = this.form && this.form.querySelector('input[type="search"]');
      if (!this.details || !this.modal || !this.input) return;

      this.sync = this.sync.bind(this);
      this.details.addEventListener('toggle', this.sync);
      this.input.addEventListener('input', this.sync);
      this.input.addEventListener('keyup', this.sync);
      this.form.addEventListener('reset', () => requestAnimationFrame(this.sync));
      this.form.querySelectorAll('button[type="reset"]').forEach((b) => b.addEventListener('click', () => requestAnimationFrame(this.sync)));
      document.addEventListener('searchmodal:close', this.sync);

      // predictive-search, sorgu boşken her keyup'ta odağı input'a geri çeker; panel içinde Tab ile gezinmeyi
      // bozmasın diye keyup panelin dışına taşmaz. Escape geçer (modalı kapatır).
      this.addEventListener('keyup', (e) => {
        if (e.key !== 'Escape') e.stopPropagation();
      });

      const summary = this.details.querySelector('summary');
      if (summary) {
        const warm = () => this.load();
        summary.addEventListener('pointerenter', warm, { once: true });
        summary.addEventListener('focus', warm, { once: true });
        summary.addEventListener('touchstart', warm, { once: true, passive: true });
      }
      this.sync();
    }

    load() {
      if (this.loading || this.loaded || !this.dataset.src) return this.loading;
      this.loading = fetch(this.dataset.src)
        .then((r) => (r.ok ? r.text() : ''))
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('.tps-search-empty__inner');
          this.loaded = true;
          if (inner) {
            this.replaceChildren(inner);
            this.empty = false;
          } else {
            this.empty = true;
          }
          this.sync();
        })
        .catch(() => {
          this.loading = null;
        });
      return this.loading;
    }

    sync() {
      const open = this.details.hasAttribute('open');
      const idle = open && !this.input.value.trim();
      if (open) this.load();
      // Modal yüksekliği açık olduğu sürece sabit; içerik yoksa (ayar boş) hiç büyütme.
      const usable = this.loaded ? !this.empty : true;
      this.modal.classList.toggle('tps-search-idle', open && usable);
      this.hidden = !(idle && this.loaded && !this.empty);
    }
  }

  customElements.define('tps-search-empty', TpsSearchEmpty);
}
